import * as i0 from '@angular/core';
import { Component, Input, ViewChild, EventEmitter, Output, Injectable, ContentChildren, HostListener, NgModule } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1 from 'ngx-toastr';
import { Toast, ToastrService, ToastPackage, ToastContainerDirective, ToastrModule, ToastContainerModule } from 'ngx-toastr';
import { BehaviorSubject, Subject } from 'rxjs';
import { BsDatepickerDirective, BsDaterangepickerDirective, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { takeUntil } from 'rxjs/operators';
import { Router, RouterModule } from '@angular/router';
import { DocumentInterruptSource, StorageInterruptSource, Idle } from '@ng-idle/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertModule } from 'ngx-bootstrap/alert';

// NOTE: These types are based on the CSS class definitions in _alerts.scss
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from 'ngx-bootstrap/alert';
import * as ɵngcc3 from 'ngx-toastr';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from 'ngx-bootstrap/datepicker';
import * as ɵngcc6 from '@angular/router';
import * as ɵngcc7 from '@ng-select/ng-select';
import * as ɵngcc8 from '@ng-idle/core';
import * as ɵngcc9 from 'ngx-bootstrap/modal';
import * as ɵngcc10 from '@ng-idle/keepalive';

function AlertInlineComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 4);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.iconClass);
} }
function AlertInlineComponent_h4_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.componentTitle);
} }
const _c0 = ["*"];
function AlertToastComponent_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 5);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.iconClasses);
} }
function AlertToastComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 6);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r1.message, ɵngcc0.ɵɵsanitizeHtml);
} }
function AlertToastComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-label", ctx_r2.message);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.message, " ");
} }
const _c1 = function (a0) { return { "is-invalid": a0 }; };
function DropdownButtonComponent_div_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.btnName);
} }
function DropdownButtonComponent_div_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 6);
} }
function DropdownButtonComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1)(1, "button", 2);
    ɵngcc0.ɵɵtemplate(2, DropdownButtonComponent_div_0_ng_container_2_Template, 2, 1, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(3, DropdownButtonComponent_div_0_ng_template_3_Template, 1, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵprojection(6);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(4);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.divClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.buttonClasses)("id", ctx_r0.dropdownId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.btnName)("ngIfElse", _r2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r0.dropdownId);
} }
const _c2 = [[["", "ods-dropdown-button-items", ""]]];
const _c3 = ["[ods-dropdown-button-items]"];
function LeftNavbarListItemComponent_a_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function LeftNavbarListItemComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵlistener("click", function LeftNavbarListItemComponent_a_1_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.onListItemClicked($event)); });
    ɵngcc0.ɵɵtemplate(1, LeftNavbarListItemComponent_a_1_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r0.tooltip);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r0.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function LeftNavbarListItemComponent_a_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function LeftNavbarListItemComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵlistener("click", function LeftNavbarListItemComponent_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.onListItemClicked($event)); });
    ɵngcc0.ɵɵtemplate(1, LeftNavbarListItemComponent_a_2_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r1.tooltip);
    ɵngcc0.ɵɵproperty("href", ctx_r1.externalLink, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
} }
function LeftNavbarListItemComponent_ng_template_3_span_0_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassMap(ctx_r12.iconIndicator);
} }
function LeftNavbarListItemComponent_ng_template_3_span_0_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span");
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r13.warningTooltip, " nav-badge-indicator");
} }
function LeftNavbarListItemComponent_ng_template_3_span_0_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r14.altIndicator);
} }
function LeftNavbarListItemComponent_ng_template_3_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtemplate(1, LeftNavbarListItemComponent_ng_template_3_span_0_i_1_Template, 1, 3, "i", 10);
    ɵngcc0.ɵɵtemplate(2, LeftNavbarListItemComponent_ng_template_3_span_0_span_2_Template, 1, 3, "span", 10);
    ɵngcc0.ɵɵtemplate(3, LeftNavbarListItemComponent_ng_template_3_span_0_span_3_Template, 2, 1, "span", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.iconIndicator);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.warningTooltip);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.altIndicator);
} }
function LeftNavbarListItemComponent_ng_template_3_span_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r15.caption);
} }
function LeftNavbarListItemComponent_ng_template_3_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, LeftNavbarListItemComponent_ng_template_3_span_1_span_2_Template, 2, 1, "span", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r11.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.caption);
} }
function LeftNavbarListItemComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, LeftNavbarListItemComponent_ng_template_3_span_0_Template, 4, 3, "span", 7);
    ɵngcc0.ɵɵtemplate(1, LeftNavbarListItemComponent_ng_template_3_span_1_Template, 3, 2, "span", 8);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.hasIndicator());
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.label);
} }
function LeftNavbarComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8)(1, "i", 9);
    ɵngcc0.ɵɵlistener("click", function LeftNavbarComponent_a_3_Template_i_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.onExpandButtonClicked($event)); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r0.expandButtonTitle);
} }
function LeftNavbarComponent_ng_container_5_i_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 14);
    ɵngcc0.ɵɵlistener("click", function LeftNavbarComponent_ng_container_5_i_1_Template_i_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r6.onExpandButtonClicked($event)); });
    ɵngcc0.ɵɵelementEnd();
} }
function LeftNavbarComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0, 10);
    ɵngcc0.ɵɵtemplate(1, LeftNavbarComponent_ng_container_5_i_1_Template, 1, 0, "i", 11);
    ɵngcc0.ɵɵelementStart(2, "span", 12);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "i", 13);
    ɵngcc0.ɵɵlistener("click", function LeftNavbarComponent_ng_container_5_Template_i_click_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.onCollapseButtonClicked($event)); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.isClicked);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.componentTitle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r1.collapseButtonTitle);
} }
const _c4 = function (a0) { return { "show": a0 }; };
function LeftNavbarComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵlistener("click", function LeftNavbarComponent_div_13_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r10.onBackdropClicked()); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c4, ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r2.isExpanded)));
} }
const _c5 = [[["", "ods-left-navbar-body-list-items", ""]], [["", "ods-left-navbar-footer-list-items", ""]]];
const _c6 = function (a0, a1) { return { "expanded": a0, "expanded-indicators-none": a1 }; };
const _c7 = ["[ods-left-navbar-body-list-items]", "[ods-left-navbar-footer-list-items]"];
function TopNavbarComponent_h1_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.componentTitle);
} }
function TopNavbarComponent_a_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TopNavbarComponent_a_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 13);
    ɵngcc0.ɵɵtemplate(1, TopNavbarComponent_a_12_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r1.helpRouterLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function TopNavbarComponent_a_13_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TopNavbarComponent_a_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 15);
    ɵngcc0.ɵɵtemplate(1, TopNavbarComponent_a_13_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵproperty("href", ctx_r2.helpExternalLink, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function TopNavbarComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 16);
} }
const _c8 = [[["", "ods-top-navbar-dropdown-items", ""]]];
const _c9 = function (a0) { return { "nav-logo-large": a0 }; };
const _c10 = ["[ods-top-navbar-dropdown-items]"];
function TopNavbarMultiComponent_h1_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1", 16);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.componentTitle);
} }
function TopNavbarMultiComponent_a_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TopNavbarMultiComponent_a_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 17);
    ɵngcc0.ɵɵtemplate(1, TopNavbarMultiComponent_a_8_ng_container_1_Template, 1, 0, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(18);
    ɵngcc0.ɵɵproperty("routerLink", ctx_r1.helpRouterLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function TopNavbarMultiComponent_a_9_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TopNavbarMultiComponent_a_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 19);
    ɵngcc0.ɵɵtemplate(1, TopNavbarMultiComponent_a_9_ng_container_1_Template, 1, 0, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(18);
    ɵngcc0.ɵɵproperty("href", ctx_r2.helpExternalLink, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function TopNavbarMultiComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 20);
} }
const _c11 = function (a0) { return { "nav-multi-logo-large": a0 }; };
function ViewContentComponent_a_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ViewContentComponent_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵtemplate(1, ViewContentComponent_a_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵpropertyInterpolate("routerLink", ctx_r0.closeButtonRouterLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ViewContentComponent_a_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ViewContentComponent_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵtemplate(1, ViewContentComponent_a_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("href", ctx_r1.closeButtonExternalLink, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function ViewContentComponent_h1_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.componentTitle);
} }
function ViewContentComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 9);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r4.closeButtonLabel);
} }
const _c12 = function (a0) { return { "container-content-sm": a0 }; };
const _c13 = ["childModal"];
var AlertInlineTypes;
(function (AlertInlineTypes) {
    AlertInlineTypes["info"] = "info";
    AlertInlineTypes["warning"] = "warning";
    AlertInlineTypes["danger"] = "danger";
    AlertInlineTypes["success"] = "success";
    AlertInlineTypes["primary"] = "primary";
})(AlertInlineTypes || (AlertInlineTypes = {}));

class AlertInlineComponent {
    constructor() {
        this.componentTitle = '';
        this.dismissible = false;
        this.timeout = '';
        this.hasIcon = false;
        this.iconClass = '';
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
        this.toggleAlertIcon();
    }
    /**
     * @deprecated The `title` property is deprecated; use `componentTitle`
     */
    get title() {
        console.warn('The "title" property is deprecated; use "componentTitle"');
        return this.componentTitle;
    }
    /**
     * @deprecated The `title` property is deprecated; use `componentTitle`
     */
    set title(value) {
        console.warn('The "title" property is deprecated in favor of "componentTitle"');
        this.componentTitle = value;
    }
    ngOnInit() {
        this.toggleAlertIcon();
    }
    toggleAlertIcon() {
        switch (this.type) {
            case AlertInlineTypes.success:
            case AlertInlineTypes.primary:
                this.iconClass = 'fa-check';
                break;
            case AlertInlineTypes.info:
                this.iconClass = 'fa-pennant';
                break;
            case AlertInlineTypes.warning:
                this.iconClass = 'fa-hand-paper';
                break;
            case AlertInlineTypes.danger:
                this.iconClass = 'fa-exclamation-triangle';
                break;
            default:
                this.iconClass = '';
                break;
        }
    }
}
AlertInlineComponent.ɵfac = function AlertInlineComponent_Factory(t) { return new (t || AlertInlineComponent)(); };
AlertInlineComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AlertInlineComponent, selectors: [["ods-alert-inline"]], inputs: { componentTitle: "componentTitle", dismissible: "dismissible", timeout: "timeout", hasIcon: "hasIcon", type: "type", title: "title" }, ngContentSelectors: _c0, decls: 6, vars: 5, consts: [[3, "type", "dismissible", "dismissOnTimeout"], ["class", "alert-icon far", "aria-hidden", "true", 3, "ngClass", 4, "ngIf"], [1, "alert-message"], ["class", "alert-heading", 4, "ngIf"], ["aria-hidden", "true", 1, "alert-icon", "far", 3, "ngClass"], [1, "alert-heading"]], template: function AlertInlineComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "alert", 0);
        ɵngcc0.ɵɵtemplate(1, AlertInlineComponent_i_1_Template, 1, 1, "i", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, AlertInlineComponent_h4_3_Template, 2, 1, "h4", 3);
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("type", ctx.type)("dismissible", ctx.dismissible)("dismissOnTimeout", ctx.timeout);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasIcon);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.componentTitle);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc2.AlertComponent], encapsulation: 2 });
AlertInlineComponent.ctorParameters = () => [];
AlertInlineComponent.propDecorators = {
    type: [{ type: Input }],
    componentTitle: [{ type: Input }],
    dismissible: [{ type: Input }],
    timeout: [{ type: Input }],
    hasIcon: [{ type: Input }],
    title: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertInlineComponent, [{
        type: Component,
        args: [{
                selector: 'ods-alert-inline',
                template: "<alert [type]=\"type\" [dismissible]=\"dismissible\" [dismissOnTimeout]=\"timeout\">\n  <i *ngIf=\"hasIcon\" class=\"alert-icon far\" [ngClass]=\"iconClass\" aria-hidden=\"true\"></i>\n\n  <div class=\"alert-message\">\n    <h4 *ngIf=\"componentTitle\" class=\"alert-heading\">{{componentTitle}}</h4>\n    <span>\n      <ng-content></ng-content>\n    </span>\n  </div>\n</alert>\n"
            }]
    }], function () { return []; }, { componentTitle: [{
            type: Input
        }], dismissible: [{
            type: Input
        }], timeout: [{
            type: Input
        }], hasIcon: [{
            type: Input
        }], type: [{
            type: Input
        }], title: [{
            type: Input
        }] }); })();

class AlertToastComponent extends Toast {
    constructor(toastrService, toastPackage) {
        super(toastrService, toastPackage);
        this.toastrService = toastrService;
        this.toastPackage = toastPackage;
        this.iconClasses = [];
        this.hasIcon = new BehaviorSubject(false);
        /* toastType */
        this._toastType = 'warning';
    }
    get toastType() {
        return this._toastType;
    }
    set toastType(type) {
        this._toastType = type;
    }
    ngOnInit() {
        this.checkToastType();
        this.checkHasIcon();
    }
    checkToastType() {
        this.toastType = this.toastClasses.split(' ')[0].replace('toast-', '');
    }
    checkHasIcon() {
        switch (this.toastType) {
            case 'success':
                this.iconClasses.push('fa-check');
                break;
            case 'info':
                this.iconClasses.push('fa-pennant');
                break;
            case 'warning':
                this.iconClasses.push('fa-hand-paper');
                break;
            case 'error':
            case 'danger':
                this.iconClasses.push('fa-exclamation-triangle');
                break;
            default:
                break;
        }
    }
}
AlertToastComponent.ɵfac = function AlertToastComponent_Factory(t) { return new (t || AlertToastComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ToastrService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ToastPackage)); };
AlertToastComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AlertToastComponent, selectors: [["ods-alert-toast"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 8, vars: 8, consts: [["class", "alert-icon far", "aria-hidden", "true", 3, "ngClass", 4, "ngIf"], ["role", "alertdialog", "aria-live", "polite", "class", "alert-toast-message", 3, "innerHTML", 4, "ngIf"], ["role", "alertdialog", "aria-live", "polite", "class", "alert-toast-message", 4, "ngIf"], ["type", "button", "aria-label", "Close", 1, "close"], ["aria-hidden", "true"], ["aria-hidden", "true", 1, "alert-icon", "far", 3, "ngClass"], ["role", "alertdialog", "aria-live", "polite", 1, "alert-toast-message", 3, "innerHTML"], ["role", "alertdialog", "aria-live", "polite", 1, "alert-toast-message"]], template: function AlertToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, AlertToastComponent_i_1_Template, 1, 1, "i", 0);
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵtemplate(3, AlertToastComponent_div_3_Template, 1, 1, "div", 1);
        ɵngcc0.ɵɵtemplate(4, AlertToastComponent_div_4_Template, 2, 2, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "button", 3)(6, "span", 4);
        ɵngcc0.ɵɵtext(7, "\u00D7");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("alert-toast alert-toast-", ctx.toastType, " alert-dismissible");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(2, 6, ctx.hasIcon));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message && ctx.options.enableHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.message && !ctx.options.enableHtml);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.AsyncPipe], encapsulation: 2, data: { animation: [
            trigger('flyInOut', [
                state('inactive', style({ opacity: 0 })),
                state('active', style({ opacity: 1 })),
                state('removed', style({ opacity: 0 })),
                transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
                transition('active => removed', animate('{{ easeTime }}ms {{ easing }}')),
            ]),
        ] } });
AlertToastComponent.ctorParameters = () => [
    { type: ToastrService },
    { type: ToastPackage }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertToastComponent, [{
        type: Component,
        args: [{
                selector: 'ods-alert-toast',
                template: "<div class=\"alert-toast alert-toast-{{toastType}} alert-dismissible\">\n  <i *ngIf=\"hasIcon | async\" class=\"alert-icon far\" [ngClass]=\"iconClasses\" aria-hidden=\"true\"></i>\n\n  <div *ngIf=\"message && options.enableHtml\" role=\"alertdialog\" aria-live=\"polite\" class=\"alert-toast-message\" [innerHTML]=\"message\">\n  </div>\n  <div *ngIf=\"message && !options.enableHtml\" role=\"alertdialog\" aria-live=\"polite\" class=\"alert-toast-message\" [attr.aria-label]=\"message\">\n    {{ message }}\n  </div>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\">\n    <span aria-hidden=\"true\">&times;</span>\n  </button>\n</div>\n",
                animations: [
                    trigger('flyInOut', [
                        state('inactive', style({ opacity: 0 })),
                        state('active', style({ opacity: 1 })),
                        state('removed', style({ opacity: 0 })),
                        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
                        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}')),
                    ]),
                ],
                preserveWhitespaces: false
            }]
    }], function () { return [{ type: ɵngcc3.ToastrService }, { type: ɵngcc3.ToastPackage }]; }, null); })();

class AlertToastContainerComponent {
    constructor(toastrService) {
        this.toastrService = toastrService;
    }
    ngOnInit() {
        this.toastrService.overlayContainer = this.toastContainer;
    }
}
AlertToastContainerComponent.ɵfac = function AlertToastContainerComponent_Factory(t) { return new (t || AlertToastContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.ToastrService)); };
AlertToastContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AlertToastContainerComponent, selectors: [["ods-alert-toast-container"]], viewQuery: function AlertToastContainerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(ToastContainerDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toastContainer = _t.first);
    } }, decls: 2, vars: 0, consts: [[1, "alert-toast-container"], ["toastContainer", ""]], template: function AlertToastContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } }, dependencies: [ɵngcc3.ToastContainerDirective], encapsulation: 2 });
AlertToastContainerComponent.ctorParameters = () => [
    { type: ToastrService }
];
AlertToastContainerComponent.propDecorators = {
    toastContainer: [{ type: ViewChild, args: [ToastContainerDirective,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertToastContainerComponent, [{
        type: Component,
        args: [{
                selector: 'ods-alert-toast-container',
                template: "<div class=\"alert-toast-container\">\n  <div toastContainer></div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc3.ToastrService }]; }, { toastContainer: [{
            type: ViewChild,
            args: [ToastContainerDirective]
        }] }); })();

class DatePickerComponent {
    constructor() {
        this.defaultDateInputFormat = 'MM/DD/YYYY';
        this.disabled = false;
        this.placeholderText = this.defaultDateInputFormat;
        this.isValid = true;
        this.configuration = {
            showWeekNumbers: false,
            // Source CSS classes are defined in
            // src/styles/_datepickers.scss
            containerClass: 'theme-ods',
            customTodayClass: 'today',
            // Any moment.js format
            // https://valor-software.com/ngx-bootstrap/#/datepicker#format
            dateInputFormat: this.dateInputFormat,
        };
        // This Input/Output pairing follows the convention for creating two-way binding
        // https://blog.angulartraining.com/tutorial-create-your-own-two-way-data-binding-in-angular-46487650ea82
        this.selectedDateChangeEventEmitter = new EventEmitter();
        this._dateInputFormat = this.defaultDateInputFormat;
    }
    get selectedDate() {
        return this._selectedDate;
    }
    set selectedDate(value) {
        this._selectedDate = value;
        this.selectedDateChangeEventEmitter.emit(this._selectedDate);
    }
    get dateInputFormat() {
        return this._dateInputFormat;
    }
    set dateInputFormat(value) {
        this._dateInputFormat = value;
        this.updateDateInputFormat();
    }
    ngOnInit() {
        this.updateDateInputFormat();
    }
    onDateButtonClicked() {
        console.log('onDateButtonClicked');
        this.datePicker.show();
    }
    updateDateInputFormat() {
        if (this.configuration) {
            this.configuration.dateInputFormat = this.dateInputFormat;
        }
    }
}
DatePickerComponent.ɵfac = function DatePickerComponent_Factory(t) { return new (t || DatePickerComponent)(); };
DatePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DatePickerComponent, selectors: [["ods-date-picker"]], viewQuery: function DatePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BsDatepickerDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datePicker = _t.first);
    } }, inputs: { disabled: "disabled", placeholderText: "placeholderText", isValid: "isValid", selectedDate: "selectedDate", dateInputFormat: "dateInputFormat", minimumDate: "minimumDate", maximumDate: "maximumDate" }, outputs: { selectedDateChangeEventEmitter: "selectedDateChange" }, decls: 5, vars: 10, consts: [[1, "input-group", "input-group-datepicker", 3, "ngClass"], ["bsDatepicker", "", "type", "text", 1, "form-control", 3, "placeholder", "disabled", "ngModel", "minDate", "maxDate", "bsConfig", "ngModelChange"], [1, "input-group-append"], ["type", "button", 1, "btn", 3, "disabled", "click"], [1, "far", "fa-calendar-alt"]], template: function DatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DatePickerComponent_Template_input_ngModelChange_1_listener($event) { return ctx.selectedDate = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2)(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function DatePickerComponent_Template_button_click_3_listener() { return ctx.onDateButtonClicked(); });
        ɵngcc0.ɵɵelement(4, "i", 4);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c1, !ctx.isValid));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.placeholderText);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("ngModel", ctx.selectedDate)("minDate", ctx.minimumDate)("maxDate", ctx.maximumDate)("bsConfig", ctx.configuration);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc5.BsDatepickerDirective, ɵngcc5.BsDatepickerInputDirective], encapsulation: 2 });
DatePickerComponent.propDecorators = {
    selectedDate: [{ type: Input }],
    dateInputFormat: [{ type: Input }],
    disabled: [{ type: Input }],
    placeholderText: [{ type: Input }],
    minimumDate: [{ type: Input }],
    maximumDate: [{ type: Input }],
    isValid: [{ type: Input }],
    datePicker: [{ type: ViewChild, args: [BsDatepickerDirective,] }],
    selectedDateChangeEventEmitter: [{ type: Output, args: ['selectedDateChange',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DatePickerComponent, [{
        type: Component,
        args: [{
                selector: 'ods-date-picker',
                template: "<div class=\"input-group input-group-datepicker\" [ngClass]=\"{ 'is-invalid': !isValid }\">\n  <input bsDatepicker\n      type=\"text\"\n      class=\"form-control\"\n      placeholder=\"{{placeholderText}}\"\n      [disabled]=\"disabled\"\n      [(ngModel)]=\"selectedDate\"\n      [minDate]=\"minimumDate\"\n      [maxDate]=\"maximumDate\"\n      [bsConfig]=\"configuration\" />\n  <div class=\"input-group-append\">\n    <button class=\"btn\" type=\"button\" (click)=\"onDateButtonClicked()\" [disabled]=\"disabled\">\n      <i class=\"far fa-calendar-alt\"></i>\n    </button>\n  </div>\n  \n</div>\n"
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], placeholderText: [{
            type: Input
        }], isValid: [{
            type: Input
        }], selectedDateChangeEventEmitter: [{
            type: Output,
            args: ['selectedDateChange']
        }], selectedDate: [{
            type: Input
        }], dateInputFormat: [{
            type: Input
        }], minimumDate: [{
            type: Input
        }], maximumDate: [{
            type: Input
        }], datePicker: [{
            type: ViewChild,
            args: [BsDatepickerDirective]
        }] }); })();

class DateRangePickerComponent {
    constructor() {
        this.defaultDateInputFormat = 'MM/DD/YYYY';
        this.disabled = false;
        this.placeholderText = `${this.defaultDateInputFormat} - ${this.defaultDateInputFormat}`;
        this.isValid = true;
        this.configuration = {
            showWeekNumbers: false,
            // Source CSS classes are defined in
            // src/styles/_datepickers.scss
            containerClass: 'theme-ods',
            customTodayClass: 'today',
            // Any moment.js format
            // https://valor-software.com/ngx-bootstrap/#/datepicker#format
            dateInputFormat: this.dateInputFormat,
            rangeInputFormat: this.dateInputFormat,
        };
        // This Input/Output pairing follows the convention for creating two-way binding
        // https://blog.angulartraining.com/tutorial-create-your-own-two-way-data-binding-in-angular-46487650ea82
        this.selectedStartDateChangeEventEmitter = new EventEmitter();
        this.selectedEndDateChangeEventEmitter = new EventEmitter();
        this.selectedDatesChangeEventEmitter = new EventEmitter();
        this.requiredSelectedDateRangeLength = 2;
        this.selectedStartDateIndex = 0;
        this.selectedEndDateIndex = 1;
        this._selectedDates = [];
        this._dateInputFormat = this.defaultDateInputFormat;
    }
    get selectedStartDate() {
        let selectedStartDate;
        if (this.hasValidSelectedDateRange()) {
            selectedStartDate = this.selectedDates[this.selectedStartDateIndex];
        }
        return selectedStartDate;
    }
    get selectedEndDate() {
        let selectedEndDate;
        if (this.hasValidSelectedDateRange()) {
            selectedEndDate = this.selectedDates[this.selectedEndDateIndex];
        }
        return selectedEndDate;
    }
    get selectedDates() {
        return this._selectedDates;
    }
    set selectedDates(value) {
        this._selectedDates = value;
        this.selectedDatesChangeEventEmitter.emit(value);
        this.selectedStartDateChangeEventEmitter.emit(this.selectedStartDate);
        this.selectedEndDateChangeEventEmitter.emit(this.selectedEndDate);
    }
    get dateInputFormat() {
        return this._dateInputFormat;
    }
    set dateInputFormat(value) {
        this._dateInputFormat = value;
        this.updateDateInputFormat();
    }
    ngOnInit() {
        this.updateDateInputFormat();
    }
    onDateButtonClicked() {
        this.dateRangePicker.show();
    }
    hasValidSelectedDateRange() {
        return this.selectedDates && this.selectedDates.length === this.requiredSelectedDateRangeLength;
    }
    updateDateInputFormat() {
        if (this.configuration) {
            this.configuration.dateInputFormat = this.dateInputFormat;
            this.configuration.rangeInputFormat = this.dateInputFormat;
        }
    }
}
DateRangePickerComponent.ɵfac = function DateRangePickerComponent_Factory(t) { return new (t || DateRangePickerComponent)(); };
DateRangePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DateRangePickerComponent, selectors: [["ods-date-range-picker"]], viewQuery: function DateRangePickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BsDaterangepickerDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.dateRangePicker = _t.first);
    } }, inputs: { disabled: "disabled", placeholderText: "placeholderText", isValid: "isValid", selectedDates: "selectedDates", dateInputFormat: "dateInputFormat", minimumDate: "minimumDate", maximumDate: "maximumDate" }, outputs: { selectedStartDateChangeEventEmitter: "selectedStartDateChange", selectedEndDateChangeEventEmitter: "selectedEndDateChange", selectedDatesChangeEventEmitter: "selectedDatesChange" }, decls: 5, vars: 10, consts: [[1, "input-group", "input-group-datepicker", 3, "ngClass"], ["bsDaterangepicker", "", "type", "text", 1, "form-control", 3, "placeholder", "disabled", "ngModel", "minDate", "maxDate", "bsConfig", "ngModelChange"], [1, "input-group-append"], ["type", "button", 1, "btn", 3, "disabled", "click"], [1, "far", "fa-calendar-alt"]], template: function DateRangePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function DateRangePickerComponent_Template_input_ngModelChange_1_listener($event) { return ctx.selectedDates = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2)(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function DateRangePickerComponent_Template_button_click_3_listener() { return ctx.onDateButtonClicked(); });
        ɵngcc0.ɵɵelement(4, "i", 4);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c1, !ctx.isValid));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("placeholder", ctx.placeholderText);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled)("ngModel", ctx.selectedDates)("minDate", ctx.minimumDate)("maxDate", ctx.maximumDate)("bsConfig", ctx.configuration);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc5.BsDaterangepickerDirective, ɵngcc5.BsDaterangepickerInputDirective], encapsulation: 2 });
DateRangePickerComponent.propDecorators = {
    selectedDates: [{ type: Input }],
    dateInputFormat: [{ type: Input }],
    disabled: [{ type: Input }],
    placeholderText: [{ type: Input }],
    minimumDate: [{ type: Input }],
    maximumDate: [{ type: Input }],
    isValid: [{ type: Input }],
    dateRangePicker: [{ type: ViewChild, args: [BsDaterangepickerDirective,] }],
    selectedStartDateChangeEventEmitter: [{ type: Output, args: ['selectedStartDateChange',] }],
    selectedEndDateChangeEventEmitter: [{ type: Output, args: ['selectedEndDateChange',] }],
    selectedDatesChangeEventEmitter: [{ type: Output, args: ['selectedDatesChange',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateRangePickerComponent, [{
        type: Component,
        args: [{
                selector: 'ods-date-range-picker',
                template: "<div class=\"input-group input-group-datepicker\" [ngClass]=\"{ 'is-invalid': !isValid }\">\n  <input bsDaterangepicker\n      type=\"text\"\n      class=\"form-control\"\n      placeholder=\"{{placeholderText}}\"\n      [disabled]=\"disabled\"\n      [(ngModel)]=\"selectedDates\"\n      [minDate]=\"minimumDate\"\n      [maxDate]=\"maximumDate\"\n      [bsConfig]=\"configuration\" />\n  <div class=\"input-group-append\">\n    <button class=\"btn\" type=\"button\" (click)=\"onDateButtonClicked()\" [disabled]=\"disabled\">\n      <i class=\"far fa-calendar-alt\"></i>\n    </button>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { disabled: [{
            type: Input
        }], placeholderText: [{
            type: Input
        }], isValid: [{
            type: Input
        }], selectedStartDateChangeEventEmitter: [{
            type: Output,
            args: ['selectedStartDateChange']
        }], selectedEndDateChangeEventEmitter: [{
            type: Output,
            args: ['selectedEndDateChange']
        }], selectedDatesChangeEventEmitter: [{
            type: Output,
            args: ['selectedDatesChange']
        }], selectedDates: [{
            type: Input
        }], dateInputFormat: [{
            type: Input
        }], minimumDate: [{
            type: Input
        }], maximumDate: [{
            type: Input
        }], dateRangePicker: [{
            type: ViewChild,
            args: [BsDaterangepickerDirective]
        }] }); })();

const NAVBAR = 'navbar';
class DropdownButtonComponent {
    constructor() {
        this.type = '';
        this.showDropdown = true; // true by default
        this.dropdownId = '';
        this.btnName = '';
        this.divClasses = ['dropdown'];
        this.buttonClasses = ['btn'];
    }
    ngOnInit() {
        if (this.type === NAVBAR) {
            this.divClasses.push('nav-dropdown');
            this.buttonClasses.push('btn-light', 'dropdown-toggle');
        }
    }
}
DropdownButtonComponent.ɵfac = function DropdownButtonComponent_Factory(t) { return new (t || DropdownButtonComponent)(); };
DropdownButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownButtonComponent, selectors: [["ods-dropdown-button"]], inputs: { type: "type", showDropdown: "showDropdown", dropdownId: "dropdownId", btnName: "btnName", divClasses: "divClasses", buttonClasses: "buttonClasses" }, ngContentSelectors: _c3, decls: 1, vars: 1, consts: [[3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["type", "button", "data-toggle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", 3, "ngClass", "id"], [4, "ngIf", "ngIfElse"], ["ellipsis", ""], [1, "dropdown-menu", "dropdown-menu-right"], [1, "far", "fa-ellipsis-h"]], template: function DropdownButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵtemplate(0, DropdownButtonComponent_div_0_Template, 7, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showDropdown);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf], encapsulation: 2 });
DropdownButtonComponent.ctorParameters = () => [];
DropdownButtonComponent.propDecorators = {
    type: [{ type: Input }],
    showDropdown: [{ type: Input }],
    dropdownId: [{ type: Input }],
    btnName: [{ type: Input }],
    divClasses: [{ type: Input }],
    buttonClasses: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ods-dropdown-button',
                template: "<div *ngIf=\"showDropdown\" [ngClass]=\"divClasses\">\n  <button [ngClass]=\"buttonClasses\" type=\"button\" [id]=\"dropdownId\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\n    <ng-container *ngIf=\"btnName; else ellipsis\">{{btnName}}</ng-container>\n    <ng-template #ellipsis><i class=\"far fa-ellipsis-h\"></i></ng-template>\n  </button>\n  <div class=\"dropdown-menu dropdown-menu-right\" [attr.aria-labelledby]=\"dropdownId\">\n    <ng-content select=\"[ods-dropdown-button-items]\"></ng-content>\n  </div>\n</div>"
            }]
    }], function () { return []; }, { type: [{
            type: Input
        }], showDropdown: [{
            type: Input
        }], dropdownId: [{
            type: Input
        }], btnName: [{
            type: Input
        }], divClasses: [{
            type: Input
        }], buttonClasses: [{
            type: Input
        }] }); })();

class MenuService {
    constructor() {
        this.LARGE_SIZE = 1008;
        if (window.innerWidth > this.LARGE_SIZE) {
            this.isExpandedMenuSubject = new BehaviorSubject(true);
        }
        else {
            this.isExpandedMenuSubject = new BehaviorSubject(false);
        }
        this.isExpandedMenu$ = this.isExpandedMenuSubject.asObservable();
        this.isClickedMenuSubject = new BehaviorSubject(true);
        this.isClickeMenu$ = this.isClickedMenuSubject.asObservable();
    }
    setIsExpandedMenu(value) {
        this.isExpandedMenuSubject.next(value);
    }
    getIsExpandedMenu() {
        return this.isExpandedMenuSubject.value;
    }
    setIsClickedMenu(value) {
        this.isClickedMenuSubject.next(value);
    }
    getIsClickedMenu() {
        return this.isClickedMenuSubject.value;
    }
}
MenuService.ɵfac = function MenuService_Factory(t) { return new (t || MenuService)(); };
MenuService.ɵprov = i0.ɵɵdefineInjectable({ factory: function MenuService_Factory() { return new MenuService(); }, token: MenuService, providedIn: "root" });
MenuService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MenuService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LeftNavbarListItemComponent {
    constructor(menuService) {
        this.menuService = menuService;
        this.routerLink = '';
        this.externalLink = '';
        this.routerLinkActiveOptions = { exact: true };
        this.iconIndicator = '';
        this.altIndicator = '';
        this.warningTooltip = '';
        this.tooltip = '';
        this.listItemClickEventEmitter = new EventEmitter();
        this._label = '';
        this._caption = '';
    }
    get label() {
        return this._label;
    }
    set label(value) {
        this._label = value;
        this.updateTooltip();
    }
    get caption() {
        return this._caption;
    }
    set caption(value) {
        this._caption = value;
        this.updateTooltip();
    }
    /**
     * @deprecated The `iconClass` property is deprecated; use `iconIndicator` or `altIndicator`
     */
    get iconClass() {
        return this.iconIndicator;
    }
    /**
     * @deprecated The `iconClass` property is deprecated; use `iconIndicator` or `altIndicator`
     */
    set iconClass(value) {
        this.iconIndicator = value;
    }
    ngOnInit() {
        this.updateTooltip();
    }
    hasIndicator() {
        return !!this.iconIndicator || !!this.altIndicator;
    }
    onListItemClicked(event) {
        this.menuService.setIsExpandedMenu(false);
        this.menuService.setIsClickedMenu(false);
        this.listItemClickEventEmitter.emit({ isExpanded: false, isClicked: false });
    }
    updateTooltip() {
        if (this.label && this.caption) {
            this.tooltip = `${this.label} ${this.caption}`;
        }
        else {
            this.tooltip = this.label;
        }
    }
}
LeftNavbarListItemComponent.ɵfac = function LeftNavbarListItemComponent_Factory(t) { return new (t || LeftNavbarListItemComponent)(ɵngcc0.ɵɵdirectiveInject(MenuService)); };
LeftNavbarListItemComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LeftNavbarListItemComponent, selectors: [["ods-left-navbar-list-item"]], inputs: { routerLink: "routerLink", externalLink: "externalLink", routerLinkActiveOptions: "routerLinkActiveOptions", iconIndicator: "iconIndicator", altIndicator: "altIndicator", warningTooltip: "warningTooltip", label: "label", caption: "caption", iconClass: "iconClass" }, outputs: { listItemClickEventEmitter: "click" }, decls: 5, vars: 3, consts: [["routerLinkActive", "active", 1, "nav-item", 3, "routerLinkActiveOptions"], [3, "routerLink", "title", "click", 4, "ngIf"], [3, "href", "title", "click", 4, "ngIf"], ["linkLayout", ""], [3, "routerLink", "title", "click"], [4, "ngTemplateOutlet"], [3, "href", "title", "click"], ["class", "nav-item-indicator", 4, "ngIf"], ["class", "nav-item-label", 4, "ngIf"], [1, "nav-item-indicator"], [3, "class", 4, "ngIf"], [4, "ngIf"], [1, "nav-item-label"], ["class", "nav-item-caption", 4, "ngIf"], [1, "nav-item-caption"]], template: function LeftNavbarListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "li", 0);
        ɵngcc0.ɵɵtemplate(1, LeftNavbarListItemComponent_a_1_Template, 2, 3, "a", 1);
        ɵngcc0.ɵɵtemplate(2, LeftNavbarListItemComponent_a_2_Template, 2, 3, "a", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, LeftNavbarListItemComponent_ng_template_3_Template, 2, 2, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("routerLinkActiveOptions", ctx.routerLinkActiveOptions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.routerLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.externalLink);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc6.RouterLink, ɵngcc6.RouterLinkActive], encapsulation: 2 });
LeftNavbarListItemComponent.ctorParameters = () => [
    { type: MenuService }
];
LeftNavbarListItemComponent.propDecorators = {
    label: [{ type: Input }],
    caption: [{ type: Input }],
    routerLink: [{ type: Input }],
    externalLink: [{ type: Input }],
    routerLinkActiveOptions: [{ type: Input }],
    iconClass: [{ type: Input }],
    iconIndicator: [{ type: Input }],
    altIndicator: [{ type: Input }],
    warningTooltip: [{ type: Input }],
    listItemClickEventEmitter: [{ type: Output, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LeftNavbarListItemComponent, [{
        type: Component,
        args: [{
                selector: 'ods-left-navbar-list-item',
                template: "<li class=\"nav-item\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"routerLinkActiveOptions\">\n  <a *ngIf=\"routerLink\" [routerLink]=\"routerLink\" title=\"{{tooltip}}\" (click)=\"onListItemClicked($event)\">\n    <ng-container *ngTemplateOutlet=\"linkLayout\"></ng-container>\n  </a>\n  <a *ngIf=\"externalLink\" [href]=\"externalLink\" title=\"{{tooltip}}\" (click)=\"onListItemClicked($event)\">\n    <ng-container *ngTemplateOutlet=\"linkLayout\"></ng-container>\n  </a>\n</li>\n\n<ng-template #linkLayout>\n  <span *ngIf=\"hasIndicator()\" class=\"nav-item-indicator\">\n    <i *ngIf=\"iconIndicator\" class=\"{{iconIndicator}}\"></i>\n    <span *ngIf=\"warningTooltip\" class=\"{{warningTooltip}} nav-badge-indicator\"></span>\n    <span *ngIf=\"altIndicator\">{{altIndicator}}</span>\n  </span>\n  <span *ngIf=\"label\" class=\"nav-item-label\">\n    {{label}}\n    <span *ngIf=\"caption\" class=\"nav-item-caption\">{{caption}}</span>\n  </span>\n</ng-template>\n"
            }]
    }], function () { return [{ type: MenuService }]; }, { routerLink: [{
            type: Input
        }], externalLink: [{
            type: Input
        }], routerLinkActiveOptions: [{
            type: Input
        }], iconIndicator: [{
            type: Input
        }], altIndicator: [{
            type: Input
        }], warningTooltip: [{
            type: Input
        }], listItemClickEventEmitter: [{
            type: Output,
            args: ['click']
        }], label: [{
            type: Input
        }], caption: [{
            type: Input
        }], iconClass: [{
            type: Input
        }] }); })();

class LeftNavbarComponent {
    constructor(menuService) {
        this.menuService = menuService;
        this.componentTitle = 'MENU';
        this.expandButtonTitle = 'Expand';
        this.collapseButtonTitle = 'Collapse';
        this.autoCollapse = false;
        this.modal = false;
        this.showExpandedIndicators = true;
        this.expandedEventEmitter = new EventEmitter();
        this.collapsedEventEmitter = new EventEmitter();
        this.isExpanded = this.menuService.isExpandedMenu$;
        this.isClicked = this.menuService.isClickeMenu$;
        this.mouseOver = false;
        this.unsubscribe = new Subject();
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        if (this.autoCollapse) {
            // Listen to the click event of each item so we can auto-collapse the navbar for navigation
            this.listItems.forEach((listItem) => {
                listItem.listItemClickEventEmitter
                    .pipe(takeUntil(this.unsubscribe))
                    .subscribe(() => {
                    this.collapseNavbar();
                });
            });
        }
    }
    ngOnDestroy() {
        // NOTE: To prevent memory leaks, we want to unsubscribe all listeners (in the simplest way possible); this
        // approach allows us to unsubscribe without having to keep track of all subscriptions
        // https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    onExpandButtonClicked(event) {
        this.menuService.setIsClickedMenu(true);
        event.preventDefault();
        this.expandNavbar();
        this.expandedEventEmitter.emit({ isExpanded: this.menuService.getIsExpandedMenu(), isClicked: this.menuService.getIsClickedMenu() });
    }
    onCollapseButtonClicked(event) {
        this.menuService.setIsClickedMenu(false);
        event.preventDefault();
        this.collapseNavbar();
        this.expandedEventEmitter.emit({ isExpanded: this.menuService.getIsExpandedMenu(), isClicked: this.menuService.getIsClickedMenu() });
    }
    onBackdropClicked() {
        this.collapseNavbar();
    }
    onMouseOvered(event) {
        if (!this.menuService.getIsExpandedMenu()) {
            event.preventDefault();
            this.mouseOver = true;
            this.expandNavbar();
            this.expandedEventEmitter.emit({ isExpanded: this.menuService.getIsExpandedMenu(), isClicked: this.menuService.getIsClickedMenu() });
        }
    }
    onMouseLeave(event) {
        if (this.menuService.getIsExpandedMenu() && !this.menuService.getIsClickedMenu()) {
            event.preventDefault();
            this.mouseOver = false;
            this.collapseNavbar();
            this.expandedEventEmitter.emit({ isExpanded: this.menuService.getIsExpandedMenu(), isClicked: this.menuService.getIsClickedMenu() });
        }
    }
    expandNavbar() {
        this.menuService.setIsExpandedMenu(true);
    }
    collapseNavbar() {
        this.menuService.setIsExpandedMenu(false);
    }
}
LeftNavbarComponent.ɵfac = function LeftNavbarComponent_Factory(t) { return new (t || LeftNavbarComponent)(ɵngcc0.ɵɵdirectiveInject(MenuService)); };
LeftNavbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LeftNavbarComponent, selectors: [["ods-left-navbar"]], contentQueries: function LeftNavbarComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, LeftNavbarListItemComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listItems = _t);
    } }, inputs: { componentTitle: "componentTitle", expandButtonTitle: "expandButtonTitle", collapseButtonTitle: "collapseButtonTitle", autoCollapse: "autoCollapse", modal: "modal", showExpandedIndicators: "showExpandedIndicators" }, outputs: { expandedEventEmitter: "expanded", collapsedEventEmitter: "collapsed" }, ngContentSelectors: _c7, decls: 14, vars: 13, consts: [[1, "container-navbar-left", 3, "ngClass"], [1, "nav-header"], ["class", "nav-expand", 3, "title", 4, "ngIf"], ["class", "nav-expand", 4, "ngIf"], [1, "nav-body", 3, "mouseover", "mouseleave"], [1, "nav-item-list"], [1, "nav-footer", 3, "mouseover", "mouseleave"], ["class", "container-navbar-left-backdrop", 3, "ngClass", "click", 4, "ngIf"], [1, "nav-expand", 3, "title"], [1, "far", "fa-bars", 3, "click"], [1, "nav-expand"], ["class", "far fa-bars nav-title", 3, "click", 4, "ngIf"], [1, "nav-title"], [1, "far", "fa-times", "nav-close", 3, "title", "click"], [1, "far", "fa-bars", "nav-title", 3, "click"], [1, "container-navbar-left-backdrop", 3, "ngClass", "click"]], template: function LeftNavbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c5);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelementStart(2, "div", 1);
        ɵngcc0.ɵɵtemplate(3, LeftNavbarComponent_a_3_Template, 2, 1, "a", 2);
        ɵngcc0.ɵɵpipe(4, "async");
        ɵngcc0.ɵɵtemplate(5, LeftNavbarComponent_ng_container_5_Template, 5, 3, "ng-container", 3);
        ɵngcc0.ɵɵpipe(6, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵlistener("mouseover", function LeftNavbarComponent_Template_div_mouseover_7_listener($event) { return ctx.onMouseOvered($event); })("mouseleave", function LeftNavbarComponent_Template_div_mouseleave_7_listener($event) { return ctx.onMouseLeave($event); });
        ɵngcc0.ɵɵelementStart(8, "ul", 5);
        ɵngcc0.ɵɵprojection(9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵlistener("mouseover", function LeftNavbarComponent_Template_div_mouseover_10_listener($event) { return ctx.onMouseOvered($event); })("mouseleave", function LeftNavbarComponent_Template_div_mouseleave_10_listener($event) { return ctx.onMouseLeave($event); });
        ɵngcc0.ɵɵelementStart(11, "ul", 5);
        ɵngcc0.ɵɵprojection(12, 1);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(13, LeftNavbarComponent_div_13_Template, 2, 5, "div", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(10, _c6, ɵngcc0.ɵɵpipeBind1(1, 4, ctx.isExpanded), !ctx.showExpandedIndicators));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ɵngcc0.ɵɵpipeBind1(4, 6, ctx.isExpanded) || ctx.mouseOver);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(6, 8, ctx.isExpanded) || ctx.mouseOver);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵproperty("ngIf", ctx.modal);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.AsyncPipe], encapsulation: 2 });
LeftNavbarComponent.ctorParameters = () => [
    { type: MenuService }
];
LeftNavbarComponent.propDecorators = {
    componentTitle: [{ type: Input }],
    expandButtonTitle: [{ type: Input }],
    collapseButtonTitle: [{ type: Input }],
    autoCollapse: [{ type: Input }],
    modal: [{ type: Input }],
    showExpandedIndicators: [{ type: Input }],
    expandedEventEmitter: [{ type: Output, args: ['expanded',] }],
    collapsedEventEmitter: [{ type: Output, args: ['collapsed',] }],
    listItems: [{ type: ContentChildren, args: [LeftNavbarListItemComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LeftNavbarComponent, [{
        type: Component,
        args: [{
                selector: 'ods-left-navbar',
                template: "<div class=\"container-navbar-left\" [ngClass]=\"{ 'expanded': (isExpanded | async), 'expanded-indicators-none': !showExpandedIndicators }\">\n    <div class=\"nav-header\">\n      <a *ngIf=\"!(isExpanded | async) || mouseOver\" class=\"nav-expand\" title=\"{{expandButtonTitle}}\">\n        <i class=\"far fa-bars\" (click)=\"onExpandButtonClicked($event)\"></i>\n      </a>\n\n      <ng-container *ngIf=\"(isExpanded | async) || mouseOver\" class=\"nav-expand\">\n        <i *ngIf=\"!isClicked\" class=\"far fa-bars nav-title\" (click)=\"onExpandButtonClicked($event)\"></i>\n        <span class=\"nav-title\">{{componentTitle}}</span>\n        <i class=\"far fa-times nav-close\" title=\"{{collapseButtonTitle}}\" (click)=\"onCollapseButtonClicked($event)\"></i>\n      </ng-container>\n    </div>\n\n    <div class=\"nav-body\" (mouseover)=\"onMouseOvered($event)\" (mouseleave)=\"onMouseLeave($event)\">\n      <ul class=\"nav-item-list\">\n        <ng-content select=\"[ods-left-navbar-body-list-items]\"></ng-content>\n      </ul>\n    </div>\n\n    <div class=\"nav-footer\" (mouseover)=\"onMouseOvered($event)\" (mouseleave)=\"onMouseLeave($event)\">\n      <ul class=\"nav-item-list\">\n        <ng-content select=\"[ods-left-navbar-footer-list-items]\"></ng-content>\n      </ul>\n    </div>\n</div>\n\n<div *ngIf=\"modal\" class=\"container-navbar-left-backdrop\" [ngClass]=\"{ 'show': isExpanded | async }\" (click)=\"onBackdropClicked()\"></div>\n"
            }]
    }], function () { return [{ type: MenuService }]; }, { componentTitle: [{
            type: Input
        }], expandButtonTitle: [{
            type: Input
        }], collapseButtonTitle: [{
            type: Input
        }], autoCollapse: [{
            type: Input
        }], modal: [{
            type: Input
        }], showExpandedIndicators: [{
            type: Input
        }], expandedEventEmitter: [{
            type: Output,
            args: ['expanded']
        }], collapsedEventEmitter: [{
            type: Output,
            args: ['collapsed']
        }], listItems: [{
            type: ContentChildren,
            args: [LeftNavbarListItemComponent]
        }] }); })();

class TopNavbarComponent {
    constructor() {
        this.componentTitle = '';
        this.logoSrc = 'assets/logo-inline-text-light.svg';
        this.logoDescription = 'Onyx CenterSource';
        this.logoRouterLink = '/';
        this.helpRouterLink = '';
        this.helpExternalLink = '';
        this.logoSize = '';
        this.userName = '';
    }
}
TopNavbarComponent.ɵfac = function TopNavbarComponent_Factory(t) { return new (t || TopNavbarComponent)(); };
TopNavbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TopNavbarComponent, selectors: [["ods-top-navbar"]], inputs: { componentTitle: "componentTitle", logoSrc: "logoSrc", logoDescription: "logoDescription", logoRouterLink: "logoRouterLink", helpRouterLink: "helpRouterLink", helpExternalLink: "helpExternalLink", logoSize: "logoSize", userName: "userName" }, ngContentSelectors: _c10, decls: 18, vars: 11, consts: [[1, "container-navbar-top"], [1, "row"], [1, "col", "py-2", "text-left"], [1, "nav-logo-link", 3, "routerLink"], [1, "img-fluid", "nav-logo", 3, "src", "alt", "ngClass"], [1, "col", "py-3"], ["class", "nav-title", 4, "ngIf"], [1, "col", "py-3", "text-right", "text-nowrap"], ["class", "nav-help", 3, "routerLink", 4, "ngIf"], ["class", "nav-help", 3, "href", 4, "ngIf"], ["type", "navbar", "dropdownId", "topNavbarDropdownMenuButton", 3, "showDropdown", "btnName"], ["helpLinkLayout", ""], [1, "nav-title"], [1, "nav-help", 3, "routerLink"], [4, "ngTemplateOutlet"], [1, "nav-help", 3, "href"], [1, "far", "fa-lg", "fa-question-circle"]], template: function TopNavbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c8);
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "a", 3);
        ɵngcc0.ɵɵelement(4, "img", 4);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtemplate(6, TopNavbarComponent_h1_6_Template, 2, 1, "h1", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "div", 5)(8, "div", 5)(9, "div", 5)(10, "div", 5);
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵtemplate(12, TopNavbarComponent_a_12_Template, 2, 2, "a", 8);
        ɵngcc0.ɵɵtemplate(13, TopNavbarComponent_a_13_Template, 2, 2, "a", 9);
        ɵngcc0.ɵɵelementStart(14, "ods-dropdown-button", 10);
        ɵngcc0.ɵɵprojection(15, 0, ["ngProjectAs", "[ods-dropdown-button-items]", 5, ["", "ods-dropdown-button-items", ""]]);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵtemplate(16, TopNavbarComponent_ng_template_16_Template, 1, 0, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("routerLink", ctx.logoRouterLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoSrc, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵpropertyInterpolate("alt", ctx.logoDescription);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c9, ctx.logoSize === "large"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.componentTitle);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helpRouterLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helpExternalLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("btnName", ctx.userName);
        ɵngcc0.ɵɵproperty("showDropdown", !!ctx.userName);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc6.RouterLink, DropdownButtonComponent], encapsulation: 2 });
TopNavbarComponent.propDecorators = {
    componentTitle: [{ type: Input }],
    logoSrc: [{ type: Input }],
    logoDescription: [{ type: Input }],
    logoRouterLink: [{ type: Input }],
    helpRouterLink: [{ type: Input }],
    helpExternalLink: [{ type: Input }],
    logoSize: [{ type: Input }],
    userName: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TopNavbarComponent, [{
        type: Component,
        args: [{
                selector: 'ods-top-navbar',
                template: "<div class=\"container-navbar-top\">\n  <div class=\"row\">\n    <div class=\"col py-2 text-left\">\n      <a [routerLink]=\"logoRouterLink\" class=\"nav-logo-link\">\n        <img src=\"{{logoSrc}}\" alt=\"{{logoDescription}}\" class=\"img-fluid nav-logo\" [ngClass]=\"{'nav-logo-large': logoSize === 'large'}\" />\n      </a>\n    </div>\n    <div class=\"col py-3\">\n      <h1 *ngIf=\"componentTitle\" class=\"nav-title\">{{componentTitle}}</h1>\n    </div>\n    <div class=\"col py-3\"></div>\n    <div class=\"col py-3\"></div>\n    <div class=\"col py-3\"></div>\n    <div class=\"col py-3\"></div>\n    <div class=\"col py-3 text-right text-nowrap\">\n      <a *ngIf=\"helpRouterLink\" [routerLink]=\"helpRouterLink\" class=\"nav-help\"><ng-container *ngTemplateOutlet=\"helpLinkLayout\"></ng-container></a>\n      <a *ngIf=\"helpExternalLink\" [href]=\"helpExternalLink\" class=\"nav-help\"><ng-container *ngTemplateOutlet=\"helpLinkLayout\"></ng-container></a>\n\n      <ods-dropdown-button type=\"navbar\" [showDropdown]=\"!!userName\" dropdownId=\"topNavbarDropdownMenuButton\" btnName=\"{{userName}}\">\n        <ng-content select=\"[ods-top-navbar-dropdown-items]\" ngProjectAs=\"[ods-dropdown-button-items]\"></ng-content>\n      </ods-dropdown-button>\n    </div>\n  </div>\n</div>\n\n<ng-template #helpLinkLayout>\n  <i class=\"far fa-lg fa-question-circle\"></i>\n</ng-template>\n"
            }]
    }], function () { return []; }, { componentTitle: [{
            type: Input
        }], logoSrc: [{
            type: Input
        }], logoDescription: [{
            type: Input
        }], logoRouterLink: [{
            type: Input
        }], helpRouterLink: [{
            type: Input
        }], helpExternalLink: [{
            type: Input
        }], logoSize: [{
            type: Input
        }], userName: [{
            type: Input
        }] }); })();

class TopNavbarMultiComponent {
    constructor() {
        this.componentTitle = '';
        this.logoSrc = 'assets/logo-inline-text-light.svg';
        this.logoDescription = 'Onyx CenterSource';
        this.logoRouterLink = '/';
        this.helpRouterLink = '';
        this.helpExternalLink = '';
        this.logoSize = '';
        this.userName = '';
        this.multiInfo = {};
        this.iataSelectedEmit = new EventEmitter();
        this.selectedFormat = {};
        this.multiListFormat = [];
        this.hasChanged = false;
        this.firstPos = 1;
        this.nextPos = 0;
        this.noFoundPos = -1;
    }
    ngOnChanges(changes) {
        if (changes.multiInfo.currentValue) {
            const tmp = [];
            this.multiInfo = changes.multiInfo.currentValue;
            this.selectedFormat = {
                value: this.multiInfo.selected.agencyId,
                name: `${this.multiInfo.selected.agencyId} - ${this.multiInfo.selected.agencyName}`,
            };
            this.multiInfo.multiList.forEach((val, i) => {
                const selectedFormatTemp = {
                    value: val.agencyId,
                    name: `${val.agencyId} - ${val.agencyName}`,
                };
                tmp.push(selectedFormatTemp);
            });
            // tslint:disable:max-line-length
            // tslint:disable:arrow-return-shorthand
            tmp.sort((x, y) => { return x.value === this.selectedFormat.value ? this.noFoundPos : y.value === this.selectedFormat.value ? this.nextPos : this.firstPos; });
            this.multiListFormat = [...tmp];
            console.log('top - ngOnChanges', this.selectedFormat);
            this.iataSelectedEmit.emit(this.selectedFormat.name);
        }
    }
    onChange(event) {
        this.hasChanged = true;
        if (event) {
            console.log('top - onChange', event);
            this.iataSelectedEmit.emit(event.name);
        }
    }
    /*public onBlur(): void {
      if (this.hasChanged && this.selectedFormat === null) {
        // To select the previous selected
        this.selectedFormat = {
          value: this.multiInfo.selected.agencyId,
          name: `${this.multiInfo.selected.agencyId} - ${this.multiInfo.selected.agencyName}`,
        } as NgSelectItem;
      }
    }*/
    compareFn(d1, d2) {
        return d1 && d2 ? d1.selected === d2.selected && d1.multiList === d2.multiList : d1 === d2;
    }
}
TopNavbarMultiComponent.ɵfac = function TopNavbarMultiComponent_Factory(t) { return new (t || TopNavbarMultiComponent)(); };
TopNavbarMultiComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TopNavbarMultiComponent, selectors: [["ods-top-navbar-multi"]], inputs: { componentTitle: "componentTitle", logoSrc: "logoSrc", logoDescription: "logoDescription", logoRouterLink: "logoRouterLink", helpRouterLink: "helpRouterLink", helpExternalLink: "helpExternalLink", logoSize: "logoSize", userName: "userName", multiInfo: "multiInfo" }, outputs: { iataSelectedEmit: "iataSelectedEmit" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c10, decls: 19, vars: 16, consts: [[1, "container-navbar-top"], [1, "row"], [1, "col", "py-2", "text-left", "col-sm-auto"], [1, "nav-logo-link", 3, "routerLink"], [1, "img-fluid", "nav-logo", 3, "src", "alt", "ngClass"], [1, "col", "pt-3"], ["class", "nav-title", 4, "ngIf"], [1, "col", "pt-3", "text-right", "pr-0"], ["class", "nav-help", 3, "routerLink", 4, "ngIf"], ["class", "nav-help", 3, "href", 4, "ngIf"], [2, "color", "white"], [1, "col", "pt-3", "text-nowrap", "px-0", "col-sm-auto"], ["name", "multiDropdown", "bindLabel", "name", "placeholder", "Search", 1, "custom", 2, "color", "white", 3, "items", "compareWith", "clearable", "searchable", "ngModel", "change", "ngModelChange"], [1, "col", "pt-3", "text-right", "text-nowrap", "col-sm-auto"], ["type", "navbar", "dropdownId", "topNavbarDropdownMenuButton", 3, "showDropdown", "btnName"], ["helpLinkLayout", ""], [1, "nav-title"], [1, "nav-help", 3, "routerLink"], [4, "ngTemplateOutlet"], [1, "nav-help", 3, "href"], [1, "far", "fa-lg", "fa-question-circle"]], template: function TopNavbarMultiComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c8);
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "a", 3);
        ɵngcc0.ɵɵelement(4, "img", 4);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵtemplate(6, TopNavbarMultiComponent_h1_6_Template, 2, 1, "h1", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 7);
        ɵngcc0.ɵɵtemplate(8, TopNavbarMultiComponent_a_8_Template, 2, 2, "a", 8);
        ɵngcc0.ɵɵtemplate(9, TopNavbarMultiComponent_a_9_Template, 2, 2, "a", 9);
        ɵngcc0.ɵɵelementStart(10, "span", 10);
        ɵngcc0.ɵɵtext(11, "Agency ID: ");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(12, "div", 11)(13, "ng-select", 12);
        ɵngcc0.ɵɵlistener("change", function TopNavbarMultiComponent_Template_ng_select_change_13_listener($event) { return ctx.onChange($event); })("ngModelChange", function TopNavbarMultiComponent_Template_ng_select_ngModelChange_13_listener($event) { return ctx.selectedFormat = $event; });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(14, "div", 13)(15, "ods-dropdown-button", 14);
        ɵngcc0.ɵɵprojection(16, 0, ["ngProjectAs", "[ods-dropdown-button-items]", 5, ["", "ods-dropdown-button-items", ""]]);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵtemplate(17, TopNavbarMultiComponent_ng_template_17_Template, 1, 0, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("routerLink", ctx.logoRouterLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("src", ctx.logoSrc, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵpropertyInterpolate("alt", ctx.logoDescription);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(14, _c11, ctx.logoSize === "large"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.componentTitle);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helpRouterLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.helpExternalLink);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("items", ctx.multiListFormat)("compareWith", ctx.compareFn)("clearable", true)("searchable", true)("ngModel", ctx.selectedFormat);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("btnName", ctx.userName);
        ɵngcc0.ɵɵproperty("showDropdown", !!ctx.userName);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc6.RouterLink, ɵngcc4.NgControlStatus, ɵngcc4.NgModel, ɵngcc7.NgSelectComponent, DropdownButtonComponent], encapsulation: 2 });
TopNavbarMultiComponent.ctorParameters = () => [];
TopNavbarMultiComponent.propDecorators = {
    componentTitle: [{ type: Input }],
    logoSrc: [{ type: Input }],
    logoDescription: [{ type: Input }],
    logoRouterLink: [{ type: Input }],
    helpRouterLink: [{ type: Input }],
    helpExternalLink: [{ type: Input }],
    logoSize: [{ type: Input }],
    userName: [{ type: Input }],
    multiInfo: [{ type: Input }],
    iataSelectedEmit: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TopNavbarMultiComponent, [{
        type: Component,
        args: [{
                selector: 'ods-top-navbar-multi',
                template: "<div class=\"container-navbar-top\">\n  <div class=\"row\">\n    <div class=\"col py-2 text-left col-sm-auto\">\n      <a [routerLink]=\"logoRouterLink\" class=\"nav-logo-link\">\n        <img src=\"{{logoSrc}}\" alt=\"{{logoDescription}}\" class=\"img-fluid nav-logo\" [ngClass]=\"{'nav-multi-logo-large': logoSize === 'large'}\" />\n      </a>\n    </div>\n    <div class=\"col pt-3\">\n      <h1 *ngIf=\"componentTitle\" class=\"nav-title\">{{componentTitle}}</h1>\n    </div>\n    <div class=\"col pt-3 text-right pr-0\">\n        <a *ngIf=\"helpRouterLink\" [routerLink]=\"helpRouterLink\" class=\"nav-help\"><ng-container *ngTemplateOutlet=\"helpLinkLayout\"></ng-container></a>\n        <a *ngIf=\"helpExternalLink\" [href]=\"helpExternalLink\" class=\"nav-help\"><ng-container *ngTemplateOutlet=\"helpLinkLayout\"></ng-container></a>\n        <span style=\" color: white\">Agency ID: </span>\n    </div>\n    <div class=\"col pt-3 text-nowrap px-0 col-sm-auto\">\n      <ng-select class=\"custom\"\n        style=\"color: white\"\n        name=\"multiDropdown\"\n        [items]=\"multiListFormat\"\n        [compareWith]=\"compareFn\"\n        [clearable]=\"true\"\n        [searchable]=\"true\"\n        (change)=\"onChange($event)\"\n        bindLabel=\"name\"\n        placeholder=\"Search\"\n        [(ngModel)]=\"selectedFormat\">\n      </ng-select>\n    </div>\n\n    <div class=\"col pt-3 text-right text-nowrap col-sm-auto\">\n      <ods-dropdown-button type=\"navbar\" [showDropdown]=\"!!userName\" dropdownId=\"topNavbarDropdownMenuButton\" btnName=\"{{userName}}\">\n        <ng-content select=\"[ods-top-navbar-dropdown-items]\" ngProjectAs=\"[ods-dropdown-button-items]\"></ng-content>\n      </ods-dropdown-button>\n    </div>\n  </div>\n</div>\n\n<ng-template #helpLinkLayout>\n  <i class=\"far fa-lg fa-question-circle\"></i>\n</ng-template>\n"
            }]
    }], function () { return []; }, { componentTitle: [{
            type: Input
        }], logoSrc: [{
            type: Input
        }], logoDescription: [{
            type: Input
        }], logoRouterLink: [{
            type: Input
        }], helpRouterLink: [{
            type: Input
        }], helpExternalLink: [{
            type: Input
        }], logoSize: [{
            type: Input
        }], userName: [{
            type: Input
        }], multiInfo: [{
            type: Input
        }], iataSelectedEmit: [{
            type: Output
        }] }); })();

class ViewContentComponent {
    constructor(menuService) {
        this.menuService = menuService;
        this.componentTitle = '';
        this.closeButtonRouterLink = '';
        this.closeButtonExternalLink = '';
        this.closeButtonLabel = '';
        this.small = false;
    }
    onClick() {
        if (this.menuService.getIsExpandedMenu() && this.menuService.getIsClickedMenu()) {
            this.menuService.setIsClickedMenu(false);
            this.menuService.setIsExpandedMenu(false);
        }
    }
}
ViewContentComponent.ɵfac = function ViewContentComponent_Factory(t) { return new (t || ViewContentComponent)(ɵngcc0.ɵɵdirectiveInject(MenuService)); };
ViewContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ViewContentComponent, selectors: [["ods-view-content"]], hostBindings: function ViewContentComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function ViewContentComponent_click_HostBindingHandler() { return ctx.onClick(); });
    } }, inputs: { componentTitle: "componentTitle", closeButtonRouterLink: "closeButtonRouterLink", closeButtonExternalLink: "closeButtonExternalLink", closeButtonLabel: "closeButtonLabel", small: "small" }, ngContentSelectors: _c0, decls: 7, vars: 6, consts: [[1, "container-fluid", "container-content", 3, "ngClass"], ["class", "content-close", 3, "routerLink", 4, "ngIf"], ["class", "content-close", 3, "href", 4, "ngIf"], ["class", "content-title", 4, "ngIf"], ["closeLinkLayout", ""], [1, "content-close", 3, "routerLink"], [4, "ngTemplateOutlet"], [1, "content-close", 3, "href"], [1, "content-title"], [1, "far", "fa-arrow-left"]], template: function ViewContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ViewContentComponent_a_1_Template, 2, 2, "a", 1);
        ɵngcc0.ɵɵtemplate(2, ViewContentComponent_a_2_Template, 2, 2, "a", 2);
        ɵngcc0.ɵɵtemplate(3, ViewContentComponent_h1_3_Template, 2, 1, "h1", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, ViewContentComponent_ng_template_5_Template, 3, 1, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c12, ctx.small));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.closeButtonLabel && ctx.closeButtonRouterLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.closeButtonLabel && ctx.closeButtonExternalLink);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.componentTitle);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc6.RouterLink], encapsulation: 2 });
ViewContentComponent.ctorParameters = () => [
    { type: MenuService }
];
ViewContentComponent.propDecorators = {
    componentTitle: [{ type: Input }],
    closeButtonRouterLink: [{ type: Input }],
    closeButtonExternalLink: [{ type: Input }],
    closeButtonLabel: [{ type: Input }],
    small: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ViewContentComponent, [{
        type: Component,
        args: [{
                selector: 'ods-view-content',
                template: "<div class=\"container-fluid container-content\" [ngClass]=\"{ 'container-content-sm': small }\">\n  <a *ngIf=\"closeButtonLabel && closeButtonRouterLink\" routerLink=\"{{closeButtonRouterLink}}\" class=\"content-close\">\n    <ng-container *ngTemplateOutlet=\"closeLinkLayout\"></ng-container>\n  </a>\n  <a *ngIf=\"closeButtonLabel && closeButtonExternalLink\" [href]=\"closeButtonExternalLink\" class=\"content-close\">\n    <ng-container *ngTemplateOutlet=\"closeLinkLayout\"></ng-container>\n  </a>\n\n  <h1 *ngIf=\"componentTitle\" class=\"content-title\">{{componentTitle}}</h1>\n\n  <ng-content></ng-content>\n</div>\n\n<ng-template #closeLinkLayout>\n  <!--\n      IMPORTANT: Do NOT change the ><span> formatting; adding a blank\n      line between </i> and <span> will insert extra space and cause\n      a hanging underline on hover\n    -->\n  <i class=\"far fa-arrow-left\"></i\n  ><span>{{closeButtonLabel}}</span>\n</ng-template>\n"
            }]
    }], function () { return [{ type: MenuService }]; }, { componentTitle: [{
            type: Input
        }], closeButtonRouterLink: [{
            type: Input
        }], closeButtonExternalLink: [{
            type: Input
        }], closeButtonLabel: [{
            type: Input
        }], small: [{
            type: Input
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

class FooterComponent {
    constructor() {
        this.footerInfo = {};
        this.mailMe = '';
        this.copyrightYear = new Date().getFullYear();
    }
    ngOnChanges(changes) {
        if (changes.footerInfo) {
            this.mailMe = `mailto:${changes.footerInfo.currentValue.email}`;
        }
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["ods-footer"]], inputs: { footerInfo: "footerInfo" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 13, vars: 5, consts: [[1, "footer", "pt-4", "pb-4"], [1, "container-fluid"], [1, "row"], [1, "col", "text-center"], [1, "text-muted"], [3, "href"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "footer", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "span", 4)(5, "strong");
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(8, "div", 2)(9, "div", 3)(10, "span", 4)(11, "a", 5);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd()()()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.footerInfo.app, " ", ctx.footerInfo.version, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" - Copyright \u00A9", ctx.copyrightYear, " Onyx CenterSource. All Rights Reserved.");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵpropertyInterpolate("href", ctx.mailMe, ɵngcc0.ɵɵsanitizeUrl);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.footerInfo.emailText);
    } }, encapsulation: 2 });
FooterComponent.ctorParameters = () => [];
FooterComponent.propDecorators = {
    footerInfo: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'ods-footer',
                template: "<footer class=\"footer pt-4 pb-4\">\n  <div class=\"container-fluid\">\n    <div class=\"row\">\n      <div class=\"col text-center\">\n        <span class=\"text-muted\"><strong>{{footerInfo.app}} {{footerInfo.version}}</strong> - Copyright \u00A9{{copyrightYear}} Onyx CenterSource. All Rights Reserved.</span>\n      </div>\n    </div>\n    <div class=\"row\">\n      <div class=\"col text-center\">\n        <span class=\"text-muted \"><a href=\"{{mailMe}}\">{{footerInfo.emailText}}</a></span>\n      </div>\n    </div>\n  </div>\n</footer>\n"
            }]
    }], function () { return []; }, { footerInfo: [{
            type: Input
        }] }); })();

class SessionTimeoutComponent {
    constructor(router, idle) {
        this.router = router;
        this.idle = idle;
        this.idleStateCounter = 'Not started.';
        this.timedOut = false;
        this.redirectionUrl = '';
        this.warningHeaderMessage = '';
        this.warningBodyMessage = '';
        this.timeoutWarningMessageDuration = 60;
        this.idleTimeoutDuration = 840;
        // @ts-ignore
        this.createCustomInterruptSources = (options) => [
            new DocumentInterruptSource('keydown mousedown touchstart touchmove' +
                'scroll', options),
            new StorageInterruptSource(options),
        ];
        this.reset = () => {
            this.idle.watch();
            this.timedOut = false;
        };
        this.stay = () => {
            this._childModal.hide();
            this.reset();
            location.reload();
        };
        this.logout = () => {
            this._childModal.hide();
            this.reset();
            this.router.navigateByUrl(this.redirectionUrl);
        };
    }
    ngOnInit() {
        this.idle.setIdle(Number(this.idleTimeoutDuration));
        this.idle.setTimeout(Number(this.timeoutWarningMessageDuration));
        this.idle.setInterrupts(this.createCustomInterruptSources(null));
        this.idle.onIdleEnd.subscribe(() => {
            this.reset();
        });
        this.idle.onTimeout.subscribe(() => {
            this._childModal.hide();
            this.timedOut = true;
            this.router.navigateByUrl(this.redirectionUrl);
        });
        this.idle.onIdleStart.subscribe(() => {
            this._childModal.show();
        });
        this.idle.onTimeoutWarning.subscribe((countdown) => {
            this.idleStateCounter = '00:' + countdown;
        });
        this.idle.watch();
    }
}
SessionTimeoutComponent.ɵfac = function SessionTimeoutComponent_Factory(t) { return new (t || SessionTimeoutComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc8.Idle)); };
SessionTimeoutComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SessionTimeoutComponent, selectors: [["ods-session-timeout"]], viewQuery: function SessionTimeoutComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c13, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._childModal = _t.first);
    } }, inputs: { redirectionUrl: "redirectionUrl", warningHeaderMessage: "warningHeaderMessage", warningBodyMessage: "warningBodyMessage", timeoutWarningMessageDuration: "timeoutWarningMessageDuration", idleTimeoutDuration: "idleTimeoutDuration" }, decls: 22, vars: 3, consts: [["bsModal", "", "tabindex", "-1", "role", "dialog", 1, "modal"], ["childModal", "bs-modal"], ["role", "document", 1, "modal-dialog"], [1, "modal-content"], [1, "modal-header", "modal-section-no-border"], ["type", "button", "data-dismiss", "modal", "aria-label", "Close", 1, "close", "modal-section-no-border", 3, "click"], ["aria-hidden", "true"], [1, "modal-body", "w-100", "text-center"], [1, "modal-footer"], ["type", "button", "data-dismiss", "modal", 1, "btn", "btn-secondary", 3, "click"], ["type", "button", 1, "btn", "btn-primary", 3, "click"]], template: function SessionTimeoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "button", 5);
        ɵngcc0.ɵɵlistener("click", function SessionTimeoutComponent_Template_button_click_5_listener() { return ctx.stay(); });
        ɵngcc0.ɵɵelementStart(6, "span", 6);
        ɵngcc0.ɵɵtext(7, "\u00D7");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(8, "div", 7)(9, "h2")(10, "strong");
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(12, "h4");
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "h2")(15, "strong");
        ɵngcc0.ɵɵtext(16);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(17, "div", 8)(18, "button", 9);
        ɵngcc0.ɵɵlistener("click", function SessionTimeoutComponent_Template_button_click_18_listener() { return ctx.logout(); });
        ɵngcc0.ɵɵtext(19, "Logout Now");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "button", 10);
        ɵngcc0.ɵɵlistener("click", function SessionTimeoutComponent_Template_button_click_20_listener() { return ctx.stay(); });
        ɵngcc0.ɵɵtext(21, "Stay Connected");
        ɵngcc0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵtextInterpolate(ctx.warningHeaderMessage);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.warningBodyMessage);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.idleStateCounter);
    } }, dependencies: [ɵngcc9.ModalDirective], encapsulation: 2 });
SessionTimeoutComponent.ctorParameters = () => [
    { type: Router },
    { type: Idle }
];
SessionTimeoutComponent.propDecorators = {
    redirectionUrl: [{ type: Input }],
    warningHeaderMessage: [{ type: Input }],
    warningBodyMessage: [{ type: Input }],
    timeoutWarningMessageDuration: [{ type: Input }],
    idleTimeoutDuration: [{ type: Input }],
    _childModal: [{ type: ViewChild, args: ['childModal', { static: false },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SessionTimeoutComponent, [{
        type: Component,
        args: [{
                selector: 'ods-session-timeout',
                template: "<div  bsModal #childModal=\"bs-modal\" class=\"modal\" tabindex=\"-1\" role=\"dialog\">\n  <div class=\"modal-dialog\" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header modal-section-no-border\">\n        <button type=\"button\" (click)=\"stay()\" class=\"close modal-section-no-border\" data-dismiss=\"modal\" aria-label=\"Close\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n      </div>\n      <div class=\"modal-body w-100 text-center\">\n        <h2><strong>{{this.warningHeaderMessage}}</strong></h2>\n        <h4>{{this.warningBodyMessage}}</h4>\n        <h2><strong>{{this.idleStateCounter}}</strong></h2>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" (click)=\"logout()\" class=\"btn btn-secondary\" data-dismiss=\"modal\">Logout Now</button>\n        <button type=\"button\" (click)=\"stay()\" class=\"btn btn-primary\">Stay Connected</button>\n      </div>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc6.Router }, { type: ɵngcc8.Idle }]; }, { redirectionUrl: [{
            type: Input
        }], warningHeaderMessage: [{
            type: Input
        }], warningBodyMessage: [{
            type: Input
        }], timeoutWarningMessageDuration: [{
            type: Input
        }], idleTimeoutDuration: [{
            type: Input
        }], _childModal: [{
            type: ViewChild,
            args: ['childModal', { static: false }]
        }] }); })();

/**
 * @deprecated This service is deprecated; use `ngx-toastr` directly or a library appropriate to your project's architectural standards
 */
class AlertToastService {
    constructor(toastr) {
        this.toastr = toastr;
    }
    success(message, hasIcon, override = {}) {
        const activeToast = this.toastr.success(message, undefined, override);
        this.setIcon(activeToast, hasIcon);
    }
    info(message, hasIcon, override = {}) {
        const activeToast = this.toastr.info(message, undefined, override);
        this.setIcon(activeToast, hasIcon);
    }
    warning(message, hasIcon, override = {}) {
        const activeToast = this.toastr.warning(message, undefined, override);
        this.setIcon(activeToast, hasIcon);
    }
    danger(message, hasIcon, override = {}) {
        const activeToast = this.toastr.error(message, undefined, override);
        this.setIcon(activeToast, hasIcon);
    }
    setIcon(activeToast, hasIcon = false) {
        if (activeToast && hasIcon) {
            const component = activeToast.toastRef.componentInstance;
            component.hasIcon.next(hasIcon);
        }
    }
}
AlertToastService.ɵfac = function AlertToastService_Factory(t) { return new (t || AlertToastService)(ɵngcc0.ɵɵinject(ɵngcc3.ToastrService)); };
AlertToastService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AlertToastService_Factory() { return new AlertToastService(i0.ɵɵinject(i1.ToastrService)); }, token: AlertToastService, providedIn: "root" });
AlertToastService.ctorParameters = () => [
    { type: ToastrService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.ToastrService }]; }, null); })();

class NgxDesignSystemComponentsModule {
}
NgxDesignSystemComponentsModule.ɵfac = function NgxDesignSystemComponentsModule_Factory(t) { return new (t || NgxDesignSystemComponentsModule)(); };
NgxDesignSystemComponentsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxDesignSystemComponentsModule });
NgxDesignSystemComponentsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        AlertToastService,
    ], imports: [CommonModule,
        RouterModule,
        FormsModule,
        AlertModule.forRoot(),
        BsDatepickerModule.forRoot(),
        ToastrModule.forRoot({
            positionClass: 'inline',
            toastComponent: AlertToastComponent,
            timeOut: 4000,
            enableHtml: true
        }),
        ToastContainerModule,
        NgSelectModule,
        ModalModule,
        NgIdleKeepaliveModule.forRoot()] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxDesignSystemComponentsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule,
                    FormsModule,
                    AlertModule.forRoot(),
                    BsDatepickerModule.forRoot(),
                    ToastrModule.forRoot({
                        positionClass: 'inline',
                        toastComponent: AlertToastComponent,
                        timeOut: 4000,
                        enableHtml: true
                    }),
                    ToastContainerModule,
                    NgSelectModule,
                    ModalModule,
                    NgIdleKeepaliveModule.forRoot(),
                ],
                entryComponents: [
                    AlertToastComponent,
                ],
                declarations: [
                    AlertInlineComponent,
                    AlertToastComponent,
                    AlertToastContainerComponent,
                    DatePickerComponent,
                    DateRangePickerComponent,
                    DropdownButtonComponent,
                    LeftNavbarListItemComponent,
                    LeftNavbarComponent,
                    TopNavbarComponent,
                    TopNavbarMultiComponent,
                    ViewContentComponent,
                    FooterComponent,
                    SessionTimeoutComponent,
                ],
                exports: [
                    AlertInlineComponent,
                    AlertToastComponent,
                    AlertToastContainerComponent,
                    DatePickerComponent,
                    DateRangePickerComponent,
                    DropdownButtonComponent,
                    LeftNavbarListItemComponent,
                    LeftNavbarComponent,
                    TopNavbarComponent,
                    TopNavbarMultiComponent,
                    ViewContentComponent,
                    FooterComponent,
                    SessionTimeoutComponent,
                ],
                providers: [
                    AlertToastService,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxDesignSystemComponentsModule, { declarations: function () { return [AlertInlineComponent, AlertToastComponent, AlertToastContainerComponent, DatePickerComponent, DateRangePickerComponent, DropdownButtonComponent, LeftNavbarListItemComponent, LeftNavbarComponent, TopNavbarComponent, TopNavbarMultiComponent, ViewContentComponent, FooterComponent, SessionTimeoutComponent]; }, imports: function () { return [CommonModule,
        RouterModule,
        FormsModule, ɵngcc2.AlertModule, ɵngcc5.BsDatepickerModule, ɵngcc3.ToastrModule, ToastContainerModule,
        NgSelectModule,
        ModalModule, ɵngcc10.NgIdleKeepaliveModule]; }, exports: function () { return [AlertInlineComponent, AlertToastComponent, AlertToastContainerComponent, DatePickerComponent, DateRangePickerComponent, DropdownButtonComponent, LeftNavbarListItemComponent, LeftNavbarComponent, TopNavbarComponent, TopNavbarMultiComponent, ViewContentComponent, FooterComponent, SessionTimeoutComponent]; } }); })();

/*
 * Public API Surface of ngx-design-system-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertInlineComponent, AlertInlineTypes, AlertToastComponent, AlertToastContainerComponent, DatePickerComponent, DateRangePickerComponent, DropdownButtonComponent, FooterComponent, LeftNavbarComponent, LeftNavbarListItemComponent, MenuService, NgxDesignSystemComponentsModule, SessionTimeoutComponent, TopNavbarComponent, TopNavbarMultiComponent, ViewContentComponent, AlertToastComponent as ɵa, AlertInlineComponent as ɵb, AlertToastContainerComponent as ɵc, DatePickerComponent as ɵd, DateRangePickerComponent as ɵe, DropdownButtonComponent as ɵf, LeftNavbarListItemComponent as ɵg, MenuService as ɵh, LeftNavbarComponent as ɵi, MenuService as ɵj, TopNavbarComponent as ɵk, TopNavbarMultiComponent as ɵl, ViewContentComponent as ɵm, FooterComponent as ɵn, SessionTimeoutComponent as ɵo, AlertToastService as ɵp };

